import { singleFinalDot } from '../../utils/sentenceEnd';
import type { TFunction } from 'i18next';
import type { TransportSupplierCargoWarningDto } from '../../types/transport';
import { formatLocalizedQuantity } from '../../utils/numberFormatting';
import { formatUnit } from '../../utils/units';

/**
 * SUPPLIER_CARGO_LINE_UNASSIGNED (contract round 8, informational, never
 * blocking): every truck of the ZD has entries and these lines are entered on
 * none. One Polish sentence per `remaining[]` line, the same on the transport
 * detail and the ZD valuation:
 * „{{product}} — nie jedzie żadnym autem, pozostało {{remaining}}.”
 */
export function unassignedSupplierLineMessages(
  warnings: TransportSupplierCargoWarningDto[] | undefined,
  t: TFunction,
  language: string,
): string[] {
  return (warnings || [])
    .filter((warning) => warning.code === 'SUPPLIER_CARGO_LINE_UNASSIGNED')
    .flatMap((warning) => warning.remaining || [])
    .map((line) => singleFinalDot(t('transport:supplierCargo.lineUnassigned', {
      product: line.position
        ? `${line.productName || '—'} (${t('transport:linePosition', { number: line.position })})`
        : line.productName || '—',
      remaining: line.quantity === null
        ? t('transport:supplierCargo.unknown')
        : `${formatLocalizedQuantity(line.quantity, language)} ${formatUnit(line.unit || 'pcs', language)}`,
    })));
}
